import React from "react";
import Tooltip from "components/Tooltip";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { BuildingCertificationSettings } from "api-client";
import { CERTIFICATIONS_CALCULATION_LOGIC } from "utils";

const CalculationLogic = ({
  type,
  className,
}: {
  type: keyof BuildingCertificationSettings;
  className?: string;
}) => {
  const { t, i18n } = useTranslation();
  const isEng = i18n.language === "en";

  const labelClassNames =
    "text-sm leading-5 font-medium text-gray-800 mb-1 flex";
  const valueClassNames = "text-sm leading-5 font-normal text-gray-500";

  const currentLogic = CERTIFICATIONS_CALCULATION_LOGIC[type];

  const databaseName = isEng
    ? currentLogic.databases.name
    : currentLogic.databases.name_de;

  const referenceAreaName = isEng
    ? currentLogic.referenceArea.name
    : currentLogic.referenceArea.name_de;

  return (
    <div className={clsx("bg-gray-50 p-4", className)}>
      <div className="text-xs text-gray-500 mb-3">
        {t("buildingSettings.calculationLogic")}
      </div>
      <div className="flex w-full flex-wrap">
        <div className="mr-4">
          <div className={labelClassNames}>
            {t("buildingSettings.EPDconformity")}
          </div>
          <div className={valueClassNames}>{currentLogic.conformity}</div>
        </div>
        <div className="mr-4">
          <div className={labelClassNames}>
            <span>{t("buildingSettings.EPDdatabasesPrioritized")}</span>
            <Tooltip
              content={t("buildingSettings.EPDdatabaseTooltip")}
              className="ml-1 text-gray-500"
            />
          </div>
          <div className={valueClassNames}>{databaseName}</div>
        </div>
        <div className="mr-4">
          <div className={labelClassNames}>
            {t("buildingSettings.LCAmodulesForTotalValues")}
          </div>
          <div className={valueClassNames}>{currentLogic.modules}</div>
        </div>
        <div className="mr-4 mt-4">
          <div className={labelClassNames}>
            {t("buildingSettings.referenceAreaLabel")}
            <Tooltip
              content={t("buildingSettings.referenceAreaTooltip")}
              className="ml-1 text-gray-500"
            />
          </div>
          <div className={valueClassNames}>{referenceAreaName}</div>
        </div>
      </div>
    </div>
  );
};

export default CalculationLogic;
